import { Box, Button, Typography } from "@mui/material";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import Player from "./Player";
const PcLanding = ({ browserName, handleInstallClick }) => {
  return (
    <Box>
      {browserName == "Edge" || browserName == "Chrome" ? (
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h6"
            style={{
              color: "#EC8305",
              textAlign: "center",
              fontSize: "1.8rem",
            }}
          >
            یادگیری زبان با فیلم و سریال
          </Typography>
          <Typography
            variant="h6"
            style={{
              color: "#DBD3D3",
              textAlign: "center",
              marginTop: "25px",
              fontSize: "1.2rem",
            }}
          >
            برای نصب در کامپیوتر یا لپ تاپ بر روی دکمه زیر کلیک کنید
          </Typography>
          <Button
            className="installWebApp"
            onClick={handleInstallClick}
            variant="contained"
            style={{
              marginTop: "25px",
              backgroundColor: "#024CAA",
              marginBottom: "50px",
            }}
            endIcon={<InstallDesktopIcon sx={{ color: "#EC8305" }} />}
          >
            <Typography
              style={{ color: "#EC8305", fontSize: "25px", fontWeight: "bold" }}
            >
              نصب برنامه
            </Typography>
          </Button>
          <Player />
          <hr />
          <a target="_blank" href="https://app.umlang.com/">
            <Typography
              style={{
                color: "#DBD3D3",
                fontSize: "14px",
                fontWeight: "lighter",
              }}
            >
              برای دریافت اپلیکیشن موبایل اینجا کلیک کنید
            </Typography>
            <PhoneAndroidIcon color="secondary" />
          </a>
          <br />
          <img
            style={{ maxWidth: "70%", height: "auto" }}
            alt="یادگیری زبان با فیلم و سریال"
            src={`${process.env.REACT_APP_SITEURL}/img/startimg.png`}
          />
        </Box>
      ) : (
        <>
          <Typography
            variant="h6"
            style={{ color: "#EC8305", textAlign: "center", fontSize: "3rem" }}
          >
            یادگیری زبان با فیلم و سریال
          </Typography>
          <Player />
          <Typography
            variant="h6"
            style={{
              color: "#DBD3D3",
              textAlign: "center",
              marginTop: "25px",
              fontSize: "2.5rem",
              borderBlockStyle: "dotted",
            }}
          >
            «برای کار با اوملنگ لطفا از مرورگر Chrome یا Edge استفاده کنید»
          </Typography>
        </>
      )}
    </Box>
  );
};

export default PcLanding;
